import React, { memo } from 'react';
import { Plus, Circle, CheckCircle2, Calendar, Flag } from 'lucide-react';

const TodosContent = memo(({ activity }) => {
  const isScrolling = activity?.action === 'scroll';
  const isChecking = activity?.action === 'check';
  const isAdding = activity?.action === 'add';
  const isTyping = activity?.action === 'type';
  
  const [actionCount, setActionCount] = React.useState(0);
  React.useEffect(() => {
    if (activity) {
      setActionCount(prev => prev + 1);
    }
  }, [activity]);
  
  const showNewTodo = actionCount > 3 && (isAdding || isTyping);
  const checkFirstTodo = actionCount > 1 && isChecking;
  const checkSecondTodo = actionCount > 5 && isChecking;

  const lists = [
    { name: 'Today', count: 5, color: '#007AFF', active: true },
    { name: 'Work', count: 8, color: '#FF9500' },
    { name: 'Personal', count: 3, color: '#34C759' },
    { name: 'Shopping', count: 2, color: '#FF3B30' }
  ];

  return (
    <div className="reminders-content">
      {/* Sidebar */}
      <div className="reminders-sidebar">
        <div className="sidebar-header">
          <h3 className="sidebar-title">My Lists</h3>
          <button className="add-list-btn">
            <Plus size={10} />
          </button>
        </div>
        
        <div className="lists">
          {lists.map((list, index) => (
            <div key={index} className={`list-item ${list.active ? 'active' : ''}`}>
              <div className="list-color" style={{ background: list.color }}></div>
              <span className="list-name">{list.name}</span>
              <span className="list-count">{list.count}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Main Content */}
      <div className="reminders-main">
        <div className="reminders-header">
          <h2 className="reminders-title">Today</h2>
          <span className="reminders-date">Friday, January 3</span>
        </div>

        <div className={`todos-list ${isScrolling ? 'scrolling' : ''}`}>
          {/* Todo Items */}
          <div className={`todo-item ${checkFirstTodo ? 'checking' : ''}`}>
            <button className={`todo-checkbox ${checkFirstTodo ? 'checked' : ''}`}>
              {checkFirstTodo ? <CheckCircle2 size={14} /> : <Circle size={14} />}
            </button>
            <div className="todo-content">
              <span className={`todo-text ${checkFirstTodo ? 'completed' : ''}`}>
                Review Q4 product roadmap
              </span>
              <div className="todo-meta">
                <Calendar size={8} />
                <span className="todo-time">10:00 AM</span>
                <Flag size={8} className="priority high" />
              </div>
            </div>
          </div>

          <div className="todo-item">
            <button className="todo-checkbox">
              <Circle size={14} />
            </button>
            <div className="todo-content">
              <span className="todo-text">
                Update API documentation
              </span>
              <div className="todo-meta">
                <Calendar size={8} />
                <span className="todo-time">2:00 PM</span>
              </div>
            </div>
          </div>

          <div className={`todo-item ${checkSecondTodo ? 'checking' : ''}`}>
            <button className={`todo-checkbox ${checkSecondTodo ? 'checked' : ''}`}>
              {checkSecondTodo ? <CheckCircle2 size={14} /> : <Circle size={14} />}
            </button>
            <div className="todo-content">
              <span className={`todo-text ${checkSecondTodo ? 'completed' : ''}`}>
                Team standup meeting
              </span>
              <div className="todo-meta">
                <Calendar size={8} />
                <span className="todo-time">3:30 PM</span>
              </div>
            </div>
          </div>

          <div className="todo-item">
            <button className="todo-checkbox">
              <Circle size={14} />
            </button>
            <div className="todo-content">
              <span className="todo-text">
                Prepare design system workshop
              </span>
              <div className="todo-meta">
                <Flag size={8} className="priority medium" />
              </div>
            </div>
          </div>

          <div className="todo-item completed">
            <button className="todo-checkbox checked">
              <CheckCircle2 size={14} />
            </button>
            <div className="todo-content">
              <span className="todo-text completed">
                Send weekly update email
              </span>
            </div>
          </div>

          {/* New Todo Being Added */}
          {showNewTodo && (
            <div className="todo-item new-todo">
              <button className="todo-checkbox">
                <Circle size={14} />
              </button>
              <div className="todo-content">
                <span className="todo-text">
                  Schedule mobile app beta testing{isTyping && <span className="typing-cursor">|</span>}
                </span>
              </div>
            </div>
          )}
        </div>

        {/* Add Todo Button */}
        <button className={`add-todo-btn ${isAdding ? 'active' : ''}`}>
          <Plus size={12} />
          <span>New Reminder</span>
        </button>
      </div>
    </div>
  );
});

TodosContent.displayName = 'TodosContent';

export default TodosContent;
